var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',[_c('div',{staticClass:"pa-4"},[_vm._t("header")],2),_c('div',{staticClass:"px-4"},[_vm._t("content")],2),_c('div',{staticClass:"pa-4"},[_vm._t("footer")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }